<template>
    <div>
        <template v-if="bill_payments === true && bills != null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="mt-0">Add bill payment</h1>
            </div>
            <div class="global-main">
                <form @submit.prevent="addBillData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Title </label>
                            <input v-model="form.title" type="text" name="title" class="form-control" :class="{ 'is-invalid': form.errors.has('title') }">
                            <has-error :form="form" field="title"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Description </label>
                            <input v-model="form.description" type="text" name="description" class="form-control" :class="{ 'is-invalid': form.errors.has('description') }">
                        </div>
                        <div class="form-group">
                            <label> Bill Company </label>
                            <select v-on:change="getBillDetail($event)" v-model="form.bill_id" name="bill_id" class="selectpicker form-control custom-select2" v-if="bills != null">
                                <option value="0" selected>Select</option>
                                <option v-for="bill in bills" v-bind:value="bill.id" v-bind:key="bill.id" :data-categoryName="bill.name">
                                   <img :src="bill.icon" alt=""> {{ bill.name }}
                                </option>
                            </select>
                            <has-error :form="form" field="bill_id"></has-error>
                        </div>
                        <div id="bill-detail" v-if="isShow">
                            <div class="form-group">
                                <label> Companies </label>
                                <select v-model="form.company_id" name="company_id" id="company_id" class="selectpicker form-control custom-select2" v-if="bills != null" @change="addBillerDetails($event)">
                                    <option value="" selected>Select</option>
                                    <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id" :data-billerCode="company.billerCode" :data-companyName="company.name">
                                        {{ company.name }}
                                    </option>
                                </select>
                                <has-error :form="form" field="company_id"></has-error>
                            </div>
                            <div class="form-group">
                                <label> Reference / Consumer No. </label>
                                <input v-model="form.reference" type="text" name="reference" class="form-control" :class="{ 'is-invalid': form.errors.has('reference') }">
                                <has-error :form="form" field="reference"></has-error>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <router-link class="btn btn-primary submit_form" to="/billPayments"> Cancel </router-link>
                        <button :disabled="form.busy" class="btn btn-primary active submit_form">Add</button>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="bill_payments === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="bill_payments === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    title : '',
                    description : '',
                    bill_id : '',
                    company_id : '',
                    reference : '',
                    billerCode : '',
                    categoryName : '',
                    companyName : '',

                }),
                bills: null,
                companies: null,
                isShow: false,
                bill_payments: null,
            }
        },
        methods: {
            addBillData() {
                this.$Progress.start();
                this.form.post('api/postFetchBillPayment')
                .then(res => {
                    if(res.data.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Bill detail added successfully');
                        this.$router.push('/billPayments');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg)
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getBillData(){
                this.$Progress.start();
                var param = 0;
                axios.get('/api/addBillPayment/'+param)
                .then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.bills = res.data.data.billCompanyCategory;
                    this.$Progress.finish();
                }).then(res =>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                }).catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    console.log(err);
                    this.$Progress.fail();
                });
            },
            addBillerDetails(data){
                var theTarget = data.target.options[data.target.options.selectedIndex].dataset; // object
                this.form.billerCode = theTarget.billercode;
                this.form.companyName = theTarget.companyname;
            },
            getBillDetail(event) {
                var theTarget = event.target.options[event.target.options.selectedIndex].dataset; // object
                this.$Progress.start();
                axios.get('/api/addBillPayment/'+event.target.value)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.isShow = true;
                        this.companies = res.data.data.billCompanySubCategory;
                        this.form.categoryName = theTarget.categoryname;
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load permissions');
                    }
                }).then(res =>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load permissions');

                });
            }
        },
        created() {

        },
        mounted() {
            this.$Progress.start();
            $('.selectpicker').selectpicker();
            this.can('bill_payments').then(result => {
                this.bill_payments = result.bill_payments;
            }).then(result => {
                if(this.bill_payments == true){
                    this.getBillData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
